import React, {useMemo, useState} from 'react';
import Table from 'react-bootstrap/Table';
import useTable from "../../hooks/useTable";
import TableFooter from "./TableFooter";

function getHighestAndLowest(numbers) {
    if (numbers.length === 0) {
        return []; // Return an empty array if the input array is empty
    }

    let highest = numbers[0];
    let lowest = numbers[0];

    for (let i = 1; i < numbers.length; i++) {
        if (numbers[i] > highest) {
            highest = numbers[i];
        }

        if (numbers[i] < lowest) {
            lowest = numbers[i];
        }
    }

    return [highest, lowest];
}

function convert_to_multiple_lvls_elevator(data)  {
    const itemsByCriteria = {};

    // Iterate over the array and group items by name and station
    for (const item of data) {
        const location = item.location;
        const station = item.station;
        const criteriaKey = `${location}_${station}`;

        if (criteriaKey in itemsByCriteria) {
            itemsByCriteria[criteriaKey].push(item);
        } else {
            itemsByCriteria[criteriaKey] = [item];
        }
    }

    // Create an array to hold the separate arrays
    let separateArrays = [];

    // Push the separate arrays to the final array
    for (const criteriaKey in itemsByCriteria) {
        let nodes = []
        let levels = []
        let newItem = {'routeNode': []}
        for (const i of itemsByCriteria[criteriaKey]) {
            nodes.push(i.routeNode)
            levels.push(...i.levels)
            newItem= {...i}
        }
        newItem.routeNode = nodes
        newItem.levels = getHighestAndLowest(levels)
        separateArrays.push(newItem)
    }
    return separateArrays
}

function TableAlerts({ data, rowsPerPage }) {
    const [page, setPage] = useState(1);
    const combinedData = useMemo(() => convert_to_multiple_lvls_elevator(data), [data]);
    const { slice, range } = useTable(combinedData, page, rowsPerPage);

    return (
        <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
            <Table striped responsive>
                <thead>
                <tr>
                    <th>Route Node</th>
                    <th>Location</th>
                    <th>Level</th>
                    <th>Station</th>
                    <th>Status</th>
                    <th>Type</th>
                    <th>Date</th>
                </tr>
                </thead>
                <tbody>
                {slice.map(item => {
                        var date = new Date(parseInt(item.date))
                        date = date.getDate() + '-' + (date.getMonth() + 1) + '-' + date.getFullYear()
                        console.log(item)

                    return (

                            item.routeNode.length > 1 ?
                                <tr style={boldRow} key={item.date}>
                                    <td>{item.routeNode.join(', ')}</td>
                                    <td>{item.location}</td>
                                    <td style={{display: "flex", flexDirection: "row"}}>{item.levels.join(', ')}</td>
                                    <td>{item.station}</td>
                                    <td>{item.status}</td>
                                    <td>{item.type}</td>
                                    <td>{item.date}</td>
                                </tr>
                                :
                                <tr key={item.date}>
                                    <td>{item.routeNode.join(', ')}</td>
                                    <td>{item.location}</td>
                                    <td style={{display: "flex", flexDirection: "row"}}>{item.levels.join(', ')}</td>
                                    <td>{item.station}</td>
                                    <td>{item.status}</td>
                                    <td>{item.type}</td>
                                    <td>{item.date}</td>
                                </tr>

                        )
                    }
                )}
                </tbody>
            </Table>
            <TableFooter range={range} slice={slice} setPage={setPage} page={page} />
        </div>
    );
}

const boldRow = {
    fontWeight: 'bold'
}

export default TableAlerts;
